import { patternFormatter } from 'react-number-format';

import { findMatchingFormat } from '@/_components';
import type { PhoneNumberQuerySchema } from '@/_schemas/phone-numbers';

export function getSafeNumberParts(number: string, calling_code: string, format: string) {
  const allFormats = format.split(',');
  const callingCode = `${calling_code.indexOf('+') > -1 ? '' : '+'}${calling_code}`;

  const numberFormat = findMatchingFormat(number, callingCode, allFormats);

  const currentFormat = `${callingCode} ${numberFormat}`;
  const allFormatsWithCallingCode = allFormats.map((format) => `${callingCode} ${format}`).join(',');

  const onlyNumber = (((number ?? '').indexOf('+') > -1 ? '' : '+') + number)
    .replace(callingCode, '')
    .replace(/\D/g, '');

  const onlyHashLength = (numberFormat.match(/#/g) || []).length;

  return {
    callingCode,
    numberFormat,
    onlyNumber,
    fullFormat: currentFormat,
    allFormatsWithCallingCode,
    onlyHashLength,
    onlyNumberLength: onlyNumber.length,
    mask: '#',
  };
}

export function sanitizePhoneNumber(phoneNumber: PhoneNumberQuerySchema): string {
  const applyFormatting = !!phoneNumber.country.phone_format;

  return !applyFormatting
    ? formatPhoneNumber(phoneNumber.number, phoneNumber.country.calling_code, phoneNumber.country.phone_format)
        .formattedNumber
    : phoneNumber.number;
}

export function formatPhoneNumber(number: string, calling_code: string, format: string) {
  const safeParts = getSafeNumberParts(number, calling_code, format);
  const formattedNumber = patternFormatter(safeParts.onlyNumber, { format: safeParts.fullFormat });

  const applyFormatting = !!format;

  return { ...safeParts, formattedNumber, applyFormatting };
}
